<!--
 * @Author: your name
 * @Date: 2020-08-18 11:28:28
 * @LastEditTime: 2020-10-09 12:43:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /backyard-ms/src/views/payroll/wage/modal/add-project.vue
-->
<template>
  <el-dialog
    :title="dataForm.id ? $t('1027') : $t('386')"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="600px"
    append-to-body
    class="add-project-dailog"
  >
    <el-form :model="dataForm" ref="dataForm" :rules="dataRule" label-width="180px" size="small">
      <el-form-item :label="$t('382')" prop="project_name">
        <el-input v-model="dataForm.project_name" placeholder="" maxlength="50" style="width: 180px"></el-input>
        <p>{{ $t('1025') }}</p>
      </el-form-item>
    </el-form>
    <!-- 确认取消 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" plain @click="dataFormSubmit" :disabled="disabled">{{ $t('131') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { payrollProjectSave } from 'api/payroll'

const dataForm = {
  project_name: '',
  project_id: ''
}
export default {
  data() {
    return {
      visible: false,
      dataForm,
      dataRule: {
        project_name: [
          {
            required: true,
            message: this.$t('1029')
          }
        ]
      },
      disabled: false
    }
  },
  methods: {
    init() {
      this.visible = true
      this.$refs.dataForm && this.$refs.dataForm.resetFields()
    },
    // 解决快速点击问题
    debounce(handler, delay) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        handler()
      }, delay)
    },
    dataFormSubmit() {
      this.dataForm.project_name = this.dataForm.project_name.trim()
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.disabled = true
          this.debounce(() => {
            payrollProjectSave(this.dataForm)
              .then(res => {
                this.disabled = false
                if (res && res.code === 1) {
                  this.visible = false
                  this.$emit('refreshTableData')
                  this.$message({
                    type: 'success',
                    message: this.dataForm.id ? this.$t('804') : this.$t('805')
                  })
                }
              })
              .catch(() => {
                this.visible = false
                this.disabled = false
              })
          }, 500)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-project-dailog {
  /deep/ .el-input .el-input__inner {
    width: 300px;
  }
}
</style>
